/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  operationsSummary(id) {
    return axios.get(`${this.url}/${id}/operations_summary`);
  }

  approvalWorkflow(id, data) {
    return axios.post(`${this.url}/${id}/approval_workflow`, data);
  }

  approveCanary(id, data) {
    return axios.post(`${this.url}/${id}/approve_canary`, data);
  }

  reconcileDelivery(id, data) {
    return axios.post(`${this.url}/${id}/reconcile_delivery`, data);
  }

  infojobsStores() {
    return axios.get(`${this.baseUrl()}/infojobs_stores`);
  }

  pandapeVacancies() {
    return axios.get(`${this.url}/pandape_vacancies`);
  }

  // Sample messages written by the AI agent for a campaign that has not been
  // created yet, so the operator can read them before scheduling.
  previewAiMessages(data) {
    return axios.post(`${this.url}/preview_ai_messages`, data);
  }
}

export default new CampaignsAPI();
